import React from 'react';

// ---------------------------------------------------------------------------
// TalitLogo
// ---------------------------------------------------------------------------
// The TALIT brand mark: a house-roof gable with a four-pane window in the
// apex over a slab-serif "T" — the "T as shelter" idea, TALIT being coined
// from hospi-TALIT-y. Same artwork as the site favicon
// (frontend/public/favicon.svg), redrawn here as an inline React SVG so it
// stays crisp at any size and can be recoloured with props.
//
// This is the *product* brand, so it belongs on the public marketing
// surfaces (LandingPage header/footer) only. The authenticated app shell
// (Dashboard.js / TopNavBar) deliberately shows a generic Hotel icon as its
// fallback instead — that chrome represents whichever tenant is signed in
// (see useTenantBranding), and stamping the TALIT mark there would be wrong
// for a hotel that hasn't uploaded its own logo.
//
// Props:
//   size   - px, applied to both width and height (default 36)
//   tile   - fill of the rounded background tile   (default '#3f9a12', TALIT green)
//   mark   - fill of the roof + T + window glyph   (default '#f7faf4', off-white)
//   className / ...rest - forwarded to the root <svg>
function TalitLogo({ size = 36, tile = '#3f9a12', mark = '#f7faf4', className = '', ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      className={className}
      role="img"
      aria-label="TALIT"
      {...rest}
    >
      <rect width="512" height="512" rx="112" fill={tile} />
      <g fill={mark}>
        {/* Roof: open chevron / gable */}
        <path d="M256 72 L452 238 A22 22 0 0 1 438 277 L423 277 L423 239 L256 122 L89 239 L89 277 L74 277 A22 22 0 0 1 60 238 Z" />
        {/* Four-pane window nested high in the apex */}
        <rect x="220" y="156" width="30" height="30" rx="6" />
        <rect x="262" y="156" width="30" height="30" rx="6" />
        <rect x="220" y="197" width="30" height="30" rx="6" />
        <rect x="262" y="197" width="30" height="30" rx="6" />
        {/* Slab-serif T: bracketed crossbar + stem on a footed base */}
        <path d="M140 292 L372 292 L372 362 L300 362 L300 430 Q300 452 322 460 L368 476 L368 494 L144 494 L144 476 L190 460 Q212 452 212 430 L212 362 L140 362 Z" />
      </g>
    </svg>
  );
}

export default TalitLogo;
